import React from 'react';
import { Image } from '../../../Image/Image';
import './PopupGroepsaankoop.scss';
export const PopupGroepsaankoop = (props) => {
    return <div className="c-detail-fiche__body">
        <div className="practical">
            <div className="left">
                <div className="inner">
                    <div className="bottom">
                        <PopupGroepsaankoopSideBar dictionary={props.dictionary} data={props.data} />
                    </div>
                </div>
            </div>
            <div className="right">
                <PopupGroepsaankoopBody dictionary={props.dictionary} blockListBodyContentHandler={props.blockListBodyContentHandler} data={props.data} />
            </div>
        </div>
    </div>;
}

const PopupGroepsaankoopSideBar = (props) => {
    return <div className='bottom'>
        <div className="info">
            <p>
                <strong>
                    {props.dictionary.theme}
                </strong>
                <br />
                {props.data.theme}
            </p>
        </div>
        <div className="info">
            <p>
                <strong>
                    {props.dictionary.contactperson}
                </strong>
                {props.data.detailSideBar.contactName != "" &&
                    <React.Fragment>
                        <br />
                        {props.data.detailSideBar.contactName}
                    </React.Fragment>
                }
                {props.data.detailSideBar.contactEmail != "" &&
                    <React.Fragment>
                        <br />
                        <a href={"mailto:"+ props.data.detailSideBar.contactEmail}> 
                            {props.data.detailSideBar.contactEmail}
                        </a>
                    </React.Fragment>
                }
                {props.data.detailSideBar.contactTelefoon != "" &&
                    <React.Fragment>
                        <br />
                        {props.data.detailSideBar.contactTelefoon}
                    </React.Fragment>
                }
            </p>
        </div>
    </div>;
}

const PopupGroepsaankoopBody = (props) => {
    const contentBlocks = props.blockListBodyContentHandler(props.data.detailBody.content);
    let links = [];
    let disclaimer = props.data.detailBody.disclaimer;
    for (let i = 0; i < props.data.detailBody.links.length; i++) {
        const link = props.data.detailBody.links[i];
        links.push(<div className='single-list'>
            <a className='c-button c-button--primary c-button--large' href={link.Url} target={link.Target}>{link.Name}</a>
        </div>);
    }
    return <div className='inner'>
        <div>
            {contentBlocks}
        </div>
        {links}
        {disclaimer?.Url &&
            <div className='link-block single-list'>
                <a href={disclaimer.Url} target={disclaimer.Target}>{disclaimer.Name}</a>
            </div>
        }
    </div>
}